(function(window, $) { 'use strict';

    var _cache = $.extend({}, {

    }, window.cache);

    function Modals() {}

    Modals.prototype.init = function( $selector ) {

        $selector = $selector || $('.modal');

        $selector.each(function() {

            var $modal = $(this),
                settings = $modal.data('mfp-settings') || {};

            $modal.magnificPopup({
                delegate: 'a.mfp-link',
                removalDelay: 350,
                tLoading: '',
                closeBtnInside: false,
                fixedContentPos: 'auto',
                closeMarkup: '<button type="button" class="mfp-close icon close"></button>',
                closeOnBgClick: false,
                midClick: true,
                preloader: true,
                gallery: {
                    enabled: ( settings.gallery !== undefined ) ? settings.gallery : true,
                    navigateByImgClick: false,
                    arrowMarkup: '<button type="button" class="mfp-arrow mfp-arrow-%dir% icon arrow-%dir%"></button>'
                },
                image: {
                    tError: '',
                    markup:
                        '<section>' +
                            '<article>' +
                                '<div class="mfp-figure">' +
                                    '<div class="row">' +
                                        '<div class="col col-8 col-offset-2">' +
                                            '<figure class="ratio">' +
                                                '<div class="mfp-img"></div>' +
                                            '</figure>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="row">' +
                                        '<div class="col col-12">' +
                                            '<div class="mfp-bottom-bar">' +
                                                '<div class="mfp-title"></div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</article>' +
                        '</section>'
                },
                iframe: {
                    tError: '',
                    markup:
                        '<section>' +
                            '<article>' +
                                '<div class="row">' +
                                    '<div class="col col-8 col-offset-2">' +
                                        '<div class="mfp-iframe-scaler">' +
                                            '<iframe class="mfp-iframe" frameborder="0" allowFullscreen></iframe>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="row">' +
                                    '<div class="col col-12">' +
                                        '<div class="mfp-bottom-bar">' +
                                            '<div class="mfp-title"></div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</article>' +
                        '</section>'
                },
                callbacks: {
                    beforeAppend: function() {
                        // remove ready class to show preloader
                        if( this.currItem.type !== 'inline' ) {
                            this.container.removeClass('mfp-s-ready');

                            // if content has iframe wait for load event
                            if( this.content.find('iframe').length > 0 ) {
                                this.content.find('iframe').off('load').on('load', function() {
                                    window.setTimeout(function() { this.wrap.addClass('mfp-image-loaded'); }.bind(this), 50);
                                }.bind(this));
                            }
                        }
                    },
                    beforeOpen: function() {
                        // add title content
                        for(var i = 0, length = this.st.items.length; i < length; i++) {
                            var $element = $(this.st.items[i]);
                            if( $element.closest('.owl-carousel-item').find('.mfp-additional-content ').length > 0 ) {
                                this.st.items[i].title = $element.closest('.owl-carousel-item').find('.mfp-additional-content').html();
                            }
                        }

                        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                        this.st.mainClass = 'mfp-zoom-in';
                    },
                    close: function() {
                        // remove title attr on close
                        for(var i = 0, length = this.st.items.length; i < length; i++) {
                            var $element = $(this.st.items[i]);
                            if( $element.closest('.owl-carousel-item').find('.mfp-additional-content ').length > 0 ) {
                                this.st.items[i].title = '';
                            }
                        }
                    },
                    open: function() {
                        $.magnificPopup.instance.next = function() {
                            this.wrap.removeClass('mfp-image-loaded');
                            window.setTimeout(function() { $.magnificPopup.proto.next.call(this); }.bind(this), 50);
                        };
                        $.magnificPopup.instance.prev = function() {
                            this.wrap.removeClass('mfp-image-loaded');
                            window.setTimeout(function() { $.magnificPopup.proto.prev.call(this); }.bind(this), 50);
                        };
                    },
                    imageLoadComplete: function() {
                        this.currItem.img.parent().css({ 'padding-bottom' : this.currItem.img[0].naturalHeight / this.currItem.img[0].naturalWidth * 100 + '%' }); // add ratio box
                        window.setTimeout(function() { this.wrap.addClass('mfp-image-loaded'); }.bind(this), 50);
                    }
                }
            });

        });

    };

    window.Modals = Modals;

})(window, jQuery);
